import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import Dashboard from 'services/Dashboard'
import PieChart from 'components/Charts/PieChart'
import ColumnChart from 'components/Charts/ColumnChart'
import HistoryDialog from 'components/Charts/HistoryDialog'
import Select from 'components/Inputs/Select'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { DateTime } from 'luxon'

import {
  InfoContainer,
  FilterContainer,
  LoadingContainer,
  SubTitle,
  InfoText,
  LinkText
} from '../../styles'

export default function SchedulesByStatus ({
  data,
  month = DateTime.now ().month,
  year = DateTime.now ().year
}) {
  const selectedDate = DateTime.local (year, month).setLocale ('pt-BR')
  const formattedDate = selectedDate.toFormat ('MMM yyyy')
  const token = AuthService.getToken ()
  const periodFilterOptions = Dashboard.PERIOD_FILTERS
  const [loading, setLoading] = useState (true)
  const [isMounted, setMounted] = useState (false)
  const [periodFilter, setPeriodFilter] = useState (null)
  const [showDetails, setShowDetails] = useState (false)
  const [schedulesByStatus, setSchedulesByStatus] = useState (null)

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    if (isMounted) setPeriodFilter (periodFilterOptions[0])
  }, [isMounted])

  useEffect (() => {
    getData ()
  }, [periodFilter])

  const getData = async () => {
    if (showDetails) try {
      setLoading (true)

      const startDate = selectedDate.minus ({ months: periodFilter.value }).startOf ('month').toISODate ()
      const endDate = selectedDate.endOf ('month').toISODate ()

      const filters = `start_date=${startDate}&end_date=${endDate}`
        
      const { data: schedulesByStatus } = await cutileiApi.get (
        `/admin/dashboard/schedules_by_status?${filters}`, requestConfig
      )

      setSchedulesByStatus ([
        ['Status', 'Realizados', 'Cliente faltou', 'Cancelados'],
        ...Object.keys (schedulesByStatus).map (month => ([
          month,
          schedulesByStatus[month].completedCount,
          schedulesByStatus[month].missedCount,
          schedulesByStatus[month].canceledCount
        ]))
      ])
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const toggleDetails = () => {
    if (!isMounted) setMounted (true)
    setShowDetails (!showDetails)
  }

  if (!data || Object.keys (data).length === 0) {
    return null
  }

  const monthSchedulesByStatus = [
    ['Status', 'Qauntidade'],
    ['Realizados', data[formattedDate]?.completedCount],
    ['Cliente faltou', data[formattedDate]?.missedCount],
    ['Cancelados', data[formattedDate]?.canceledCount]
  ]

  return (
    <InfoContainer>
      <SubTitle>Agendamentos por status - {selectedDate.toFormat ('MMMM / yyyy')}</SubTitle>
      <PieChart
        data={monthSchedulesByStatus}
        format='amount'
        options={{colors: ['#44CF6C', '#FFC100', '#FF3939']}}
      />
      <LinkText onClick={toggleDetails}>
        Ver histórico
      </LinkText>
      <HistoryDialog
        visible={showDetails}
        title='Agendamentos por status'
        onClose={toggleDetails}
      >
        <FilterContainer>
          <Select
            name='periodFilter'
            placeholder='Período...'
            value={periodFilter}
            options={periodFilterOptions}
            onChange={(_, option) => setPeriodFilter (option)}
            containerStyles={{width: 250}}
          />
        </FilterContainer>
        {loading ? (
          <LoadingContainer>
            <Loading/>
            <InfoText>Gerando gráfico...</InfoText>
          </LoadingContainer>
        ) : (
          <ColumnChart
            data={schedulesByStatus}
            options={{
              isStacked: false,
              colors: ['#44CF6C', '#FFC100', '#FF3939'],
              chartArea: {
                top: 35, left: 110, width: '100%', height: '80%'
              },
              vAxis: {
                title: 'Agendamentos',
                titleTextStyle: {
                  bold: true
                }
              }
            }}
          />
        )}
      </HistoryDialog>
    </InfoContainer>
  )
}
